import { Transition } from '@headlessui/react';

import type {
    IGPostTypesType,
    IGStoryTypesType,
    TIPostTypesType,
    FBPostTypesType,
    TWPostTypesType,
    LIPostTypesType,
    YTPostTypesType,
    PIPostTypesType
} from '@/lib/posts/postTypes';

import Post from '@/components/base/Post';

type AlbumPostIconProps = {
    show: boolean;
    type:
        | IGPostTypesType
        | IGStoryTypesType
        | TIPostTypesType
        | FBPostTypesType
        | TWPostTypesType
        | LIPostTypesType
        | YTPostTypesType
        | PIPostTypesType;
};

export function AlbumPostIcon({ show, type }: AlbumPostIconProps) {
    return (
        <span className="absolute right-0 top-0 z-1">
            <Transition show={show}>
                <Transition.Child
                    enter="transition ease-in-out duration-75 transform"
                    enterFrom="translate-x-full opacity-0"
                    enterTo="translate-x-0 opacity-100"
                    leave="transition ease-in-out duration-75 transform"
                    leaveFrom="translate-x-0 opacity-100"
                    leaveTo="translate-x-full opacity-0">
                    <Post.PostTypeIcon type={type} />
                </Transition.Child>
            </Transition>
        </span>
    );
}
